// components/LoadFormModal.tsx
import React from "react";
import Modal from "Common/Components/Modal";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import FarmerInfoForModal from "Common/FarmerInfoForModal";
import FarmerIdentityInfo from "Common/Components/FarmerIdentityInfo";

interface LoadFormModalProps {
  show: boolean;
  isEdit: boolean;
  onHide: () => void;
  onSubmit: () => void;
  validation: any;
  selectedCommitment: any;
  setSelectedCommitment: (commitment: any) => void;
  setMainIDfarmer: (id: string) => void;
  setSearchValueCommit: (value: string) => void;
  commitment_idList: any[];
  mainIDFarmer: string;
  isLoading: boolean;
  selectedFarmerInfo: any;
  dataFactoryID: string;
  setDataFactoryID: (id: string) => void;
  dataFactoryList: any[];
  Datevalues: any;
  setDatevaluesValues: (date: any) => void;
  isLoadingBtn: boolean;
  isEditCrepID: string;
  YearCoptSelect: string;
  formatNumber: (num: number | string) => string;
  parseFormattedNumber: (formattedNum: string) => string;
}

const LoadFormModal: React.FC<LoadFormModalProps> = ({
  show,
  isEdit,
  onHide,
  onSubmit,
  validation,
  selectedCommitment,
  setSelectedCommitment,
  setMainIDfarmer,
  setSearchValueCommit,
  commitment_idList,
  mainIDFarmer,
  isLoading,
  selectedFarmerInfo,
  dataFactoryID,
  setDataFactoryID,
  dataFactoryList,
  Datevalues,
  setDatevaluesValues,
  isLoadingBtn,
  isEditCrepID,
  YearCoptSelect,
  formatNumber,
  parseFormattedNumber,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName="w-screen md:w-[55rem] bg-white shadow rounded-md dark:bg-zink-600"
    >
      <Modal.Header
        className="flex items-center justify-between p-4 border-b dark:border-zink-500"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
      >
        <Modal.Title className="text-16">
          {!!isEdit ? "به روز رسانی بار" : "ثبت بار جدید"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <form onSubmit={validation.handleSubmit}>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
            {/* Farmer selection */}
            <div className="mb-3">
              <label htmlFor="farmer_id" className="block mb-2">
                نام کشاورز:
              </label>
              <Select
                id="farmer_id"
                name="farmer_id"
                value={selectedCommitment}
                options={commitment_idList?.map((item: any) => ({
                  value: item.farmer_id,
                  label: item.farmer_name,
                  mainID: item.id,
                }))}
                onChange={(selected: any) => {
                  setSelectedCommitment(selected);
                  setMainIDfarmer(selected.mainID);
                  validation.setFieldValue("farmer_id", selected.value);
                }}
                onInputChange={(inputValue) => {
                  setSearchValueCommit(inputValue);
                }}
                onBlur={validation.handleBlur}
                className="basic-single"
                classNamePrefix="select"
                placeholder="انتخاب کشاورز"
              />
              {!isEdit && mainIDFarmer && (
                <div className="mt-3">
                  {isLoading ? (
                    <span className="bg-green-200 dark:bg-zink-600 p-2 rounded-md text-xs text-gray-500 ">
                      در حال دریافت داده ...
                    </span>
                  ) : (
                    <FarmerInfoForModal
                      selectedFarmerInfo={selectedFarmerInfo}
                    />
                  )}
                </div>
              )}
              {!isEdit && (
                <FarmerIdentityInfo
                  farmerId={validation.values.farmer_id}
                  className="mt-3"
                />
              )}
            </div>

            {/* Factory ID */}
            <div className="flex flex-col">
              <label htmlFor="province" className="text-base font-medium mb-1">
                نام کارخانه:
              </label>
              <Select
                value={
                  dataFactoryID
                    ? {
                        value: dataFactoryID,
                        label:
                          dataFactoryList.find(
                            (item: any) => item.id == dataFactoryID
                          )?.factory_name || "",
                      }
                    : null
                }
                options={dataFactoryList.map((item: any) => ({
                  value: item.id,
                  label: item.factory_name,
                }))}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base, state) => ({
                    ...base,
                    backgroundColor: "inherit",
                    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: "inherit",
                    "&:hover": {
                      backgroundColor: "#2684FF",
                    },
                  }),
                }}
                menuPortalTarget={document.body}
                onChange={(selected: any) => setDataFactoryID(selected.value)}
                placeholder="جستجو..."
                noOptionsMessage={() => "داده‌ای دریافت نشد"}
                loadingMessage={() => "در حال بارگذاری..."}
                className="w-full my-react-select-container"
                classNamePrefix="my-react-select"
                maxMenuHeight={300}
                isSearchable
              />
            </div>

            {/* Date */}
            <div className="mb-3">
              <label htmlFor="date" className="block mb-2">
                تاریخ
              </label>
              <DatePicker
                calendar={persian}
                locale={persian_fa}
                value={Datevalues}
                onChange={setDatevaluesValues}
                format="YYYY/MM/DD"
                calendarPosition="bottom-right"
                containerClassName="w-full"
                inputClass="form-input w-full p-2 border border-gray-200 rounded bg-white text-gray-900 dark:text-white dark:bg-[#132337]"
              />
              {validation.touched.date && validation.errors.date && (
                <div className="text-red-500 text-sm mt-1">
                  {validation.errors.date}
                </div>
              )}
            </div>

            {/* Load Number */}
            <div className="mb-3">
              <label htmlFor="load_number" className="block mb-2">
                شماره بار
              </label>
              <input
                id="load_number"
                name="load_number"
                type="text"
                className="w-full p-2 border rounded"
                value={validation.values.load_number}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
              />
              {validation.touched.load_number &&
                validation.errors.load_number && (
                  <div className="text-red-500 text-sm mt-1">
                    {validation.errors.load_number}
                  </div>
                )}
            </div>

            {/* Driver Name */}
            <div className="mb-3">
              <label htmlFor="driver_name" className="block mb-2">
                نام راننده
              </label>
              <input
                id="driver_name"
                name="driver_name"
                type="text"
                className="w-full p-2 border rounded"
                value={validation.values.driver_name}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
              />
              {validation.touched.driver_name &&
                validation.errors.driver_name && (
                  <div className="text-red-500 text-sm mt-1">
                    {validation.errors.driver_name}
                  </div>
                )}
            </div>

            {/* Phone Number */}
            <div className="mb-3">
              <label htmlFor="phone_number" className="block mb-2">
                شماره همراه راننده
              </label>
              <input
                id="phone_number"
                name="phone_number"
                type="tel"
                className="w-full p-2 border rounded"
                value={validation.values.phone_number}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
              />
            </div>

            {/* Total Weight */}
            <div className="mb-3">
              <label htmlFor="total_weight" className="block mb-2">
                وزن کل (کیلوگرم)
              </label>
              <input
                id="total_weight"
                name="total_weight"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.total_weight)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("total_weight", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
              {validation.touched.total_weight &&
                validation.errors.total_weight && (
                  <div className="text-red-500 text-sm mt-1">
                    {validation.errors.total_weight}
                  </div>
                )}
            </div>

            {/* Dirt Weight */}
            <div className="mb-3">
              <label htmlFor="dirt_weight" className="block mb-2">
                وزن خاک (کیلوگرم)
              </label>
              <input
                id="dirt_weight"
                name="dirt_weight"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.dirt_weight)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("dirt_weight", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
              {validation.touched.dirt_weight &&
                validation.errors.dirt_weight && (
                  <div className="text-red-500 text-sm mt-1">
                    {validation.errors.dirt_weight}
                  </div>
                )}
            </div>

            {/* Pest Weight */}
            <div className="mb-3">
              <label htmlFor="pest_weight" className="block mb-2">
                وزن افت (کیلوگرم)
              </label>
              <input
                id="pest_weight"
                name="pest_weight"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.pest_weight)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("pest_weight", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
              {validation.touched.pest_weight &&
                validation.errors.pest_weight && (
                  <div className="text-red-500 text-sm mt-1">
                    {validation.errors.pest_weight}
                  </div>
                )}
            </div>

            {/* Pure Weight */}
            <div className="mb-3">
              <label htmlFor="pure_weight" className="block mb-2">
                وزن خالص (کیلوگرم)
              </label>
              <input
                id="pure_weight"
                name="pure_weight"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.pure_weight)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("pure_weight", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
            </div>

            {/* Sugar Beet Polarity */}
            <div className="mb-3">
              <label htmlFor="sugar_beet_polarity" className="block mb-2">
                عیار چغندرقند (%)
              </label>
              <input
                id="sugar_beet_polarity"
                name="sugar_beet_polarity"
                type="number"
                step="0.01"
                className="w-full p-2 border rounded"
                value={validation.values.sugar_beet_polarity}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
              />
              {validation.touched.sugar_beet_polarity &&
                validation.errors.sugar_beet_polarity && (
                  <div className="text-red-500 text-sm mt-1">
                    {validation.errors.sugar_beet_polarity}
                  </div>
                )}
            </div>

            {/* Price Per Kilo */}
            <div className="mb-3">
              <label htmlFor="price_per_kilo" className="block mb-2">
                قیمت هر کیلو (ریال)
              </label>
              <input
                id="price_per_kilo"
                name="price_per_kilo"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.price_per_kilo)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("price_per_kilo", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
              {validation.touched.price_per_kilo &&
                validation.errors.price_per_kilo && (
                  <div className="text-red-500 text-sm mt-1">
                    {validation.errors.price_per_kilo}
                  </div>
                )}
            </div>

            {/* Rent Help */}
            <div className="mb-3">
              <label htmlFor="rent_help" className="block mb-2">
                کمک کرایه (ریال)
              </label>
              <input
                id="rent_help"
                name="rent_help"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.rent_help)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("rent_help", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
            </div>

            {/* Transportation Cost */}
            <div className="mb-3">
              <label htmlFor="transportation_cost" className="block mb-2">
                کرایه حمل (ریال)
              </label>
              <input
                id="transportation_cost"
                name="transportation_cost"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.transportation_cost)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("transportation_cost", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
            </div>

            {/* Quota Sugar Price */}
            <div className="mb-3">
              <label htmlFor="quota_sugar_price" className="block mb-2">
                بهای قند سهمیه (ریال)
              </label>
              <input
                id="quota_sugar_price"
                name="quota_sugar_price"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.quota_sugar_price)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("quota_sugar_price", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
            </div>

            {/* Quota Pulp Price */}
            <div className="mb-3">
              <label htmlFor="quota_pulp_price" className="block mb-2">
                بهای تفاله سهمیه (ریال)
              </label>
              <input
                id="quota_pulp_price"
                name="quota_pulp_price"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.quota_pulp_price)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("quota_pulp_price", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
            </div>

            {/* Pure Payable */}
            <div className="mb-3">
              <label htmlFor="pure_payable" className="block mb-2">
                خالص پرداختی (ریال)
              </label>
              <input
                id="pure_payable"
                name="pure_payable"
                type="text"
                className="w-full p-2 border rounded"
                value={formatNumber(validation.values.pure_payable)}
                onChange={(e) => {
                  const rawValue = parseFormattedNumber(e.target.value);
                  if (!isNaN(Number(rawValue))) {
                    validation.setFieldValue("pure_payable", rawValue);
                  }
                }}
                onBlur={validation.handleBlur}
              />
            </div>
          </div>

          <div className="mt-4">
            سال زراعی انتخاب شده:{" "}
            <span className="text-custom-600 dark:text-gray-200 bold">
              {isEdit ? isEditCrepID : YearCoptSelect ? YearCoptSelect : ""}{" "}
            </span>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
        <button
          type="button"
          onClick={onSubmit}
          className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          disabled={isLoadingBtn || validation.isSubmitting}
        >
          {isLoadingBtn
            ? "در حال ارسال..."
            : isEdit
            ? "به روز رسانی اطلاعات"
            : "ثبت اطلاعات"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoadFormModal;
